import React, { createContext, useContext, useEffect, useState } from "react";
import { loadSiteConfig } from "./api/publicApi";

/**
 * Carries the one flag from the `site_config` table that the public site cares
 * about: whether apartments are shown at all.
 *
 * `ready` matters as much as `maintenance`. Until the row has been read we do
 * not know which page to draw, and rendering the home page first would flash a
 * screen full of listings before replacing it — exactly what maintenance mode
 * exists to prevent. Only the two pages that list apartments wait for it; every
 * other route renders immediately.
 *
 * The default is deliberately "not in maintenance", so a failed read leaves the
 * site working. See loadSiteConfig().
 */
const SiteConfigContext = createContext({ maintenance: false, ready: false });

export function SiteConfigProvider({ children }) {
  const [config, setConfig] = useState({ maintenance: false, ready: false });

  useEffect(function () {
    var alive = true;
    loadSiteConfig().then(function (value) {
      if (alive) setConfig({ maintenance: value.maintenance === true, ready: true });
    });
    return function () {
      alive = false;
    };
  }, []);

  return (
    <SiteConfigContext.Provider value={config}>
      {children}
    </SiteConfigContext.Provider>
  );
}

export function useSiteConfig() {
  return useContext(SiteConfigContext);
}
